import { useParams } from 'react-router';

import { FormikHelpers } from 'formik';
import { enqueueSnackbar } from 'notistack';

import { StoreOptionsProps } from 'components/autocompletes/StoreAutoComplete';
import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { ConfigPedidoProdutos } from 'pages/compra/configuracao-pedido/types';

const getFormattedProducts = (formData: ConfigPedidoProdutos, id?: string) =>
    formData.configPedidoProdutos.map((produto) => ({
        ...produto,
        configPedido: { idConfigPedido: Number(id) },
    }));

export function useMutateProdutos(loja: StoreOptionsProps | null) {
    const { mutate, isLoading } = useFormMutation();
    const { setActiveStepSaved } = useConfigPedidoStepContext();
    const { showError } = useShowError();
    const { id } = useParams();

    const onSubmit = (formData: ConfigPedidoProdutos, formik: FormikHelpers<ConfigPedidoProdutos>) => {
        let url = `/gestao/configpedidoproduto/insertlist?idConfigPedido=${id}`;
        if (loja) url += `&idLoja=${loja.idLoja}`;

        mutate(
            {
                url,
                formik,
                formData: getFormattedProducts(formData, id),
                preventSnack: true,
                preventRedirect: true,
            },
            {
                onSuccess: ({ data }: any) => {
                    enqueueSnackbar('Produtos salvos com sucesso', { variant: 'success' });

                    setActiveStepSaved();

                    formik.resetForm({ values: { configPedidoProdutos: data } });
                },
                onError: (error: unknown) => showError(error, 'Erro ao salvar Produtos'),
            },
        );
    };

    return { onSubmit, isLoading };
}
